import { render, staticRenderFns } from "./CsvPreview.vue?vue&type=template&id=20da8edb&"
import script from "./CsvPreview.vue?vue&type=script&lang=js&"
export * from "./CsvPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports